import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';

/** libraries */

import { CarouselModule } from 'ngx-owl-carousel-o';
// import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ChartsModule } from 'ng2-charts';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DataTableModule } from 'angular7-data-table';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { ShareModule } from '@ngx-share/core';

import { ShareButtonsModule } from '@ngx-share/buttons';


// import { ShareButtonsConfig } from '@ngx-share/core';
// import { ShareButtonsModule } from '@ngx-share/buttons';

// const customConfig: ShareButtonsConfig = {
//   include: ['facebook', 'twitter', 'google'],
//   exclude: ['tumblr', 'stumble', 'vk'],
//   theme: 'modern-light',
//   gaTracking: true,
//   twitterAccount: 'twitterUsername'
// }

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './partials/header/header.component';
import { NavbarComponent } from './partials/navbar/navbar.component';
import { BannerComponent } from './partials/banner/banner.component';

/** Interceptor */

import { LoaderInterceptor } from './interceptors/loader.interceptor';

/** services */

import { LoaderService } from './services/loader/loader.service';

/** pages */

import { HomeComponent } from './pages/home/home.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { LibrariesComponent } from './pages/libraries/libraries.component';
import { PublicationsComponent } from './pages/publications/publications.component';
import { MunicipalitiesComponent } from './pages/municipalities/municipalities.component';
import { PublicationDetailsComponent } from './pages/publications/publication-details/publication-details.component';
import { AgnoskojComponent } from './pages/agnoskoj/agnoskoj.component';


/** components */

import { IndicatorsHomeComponent } from './components/indicators-home/indicators-home.component';
import { CardComponent } from './components/card/card.component';
import { CardPracticesComponent } from './components/card-practices/card-practices.component';

import { TitleSectionComponent } from './components/title-section/title-section.component';
import { LastNewsHorizontalComponent } from './components/last-news-horizontal/last-news-horizontal.component';
import { LoaderComponent } from './partials/loader/loader.component';
import { IndicatorsComponent } from './pages/indicators/indicators.component';
import { IndicatorsMunicipalityComponent } from './pages/indicators-municipality/indicators-municipality.component';
import { NewsComponent } from './pages/news/news.component';
import { FooterComponent } from './partials/footer/footer.component';
import { NewsDetailsComponent } from './pages/news/news-details/news-details.component';
import { SharingButtonsComponent } from './partials/sharing-buttons/sharing-buttons.component';
import { CapitalsComponent } from './pages/capitals/capitals.component';
import { StatesComponent } from './pages/states/states.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GoodPracticesComponent } from './pages/good-practices/good-practices.component';
import { GoodPracticesDetailsComponent } from './pages/good-practices/good-practices-details/good-practices-details.component';
import { NgxGalleryModule } from 'ngx-gallery';
import { ModalesModule } from './modals/modales.module';

import 'hammerjs';

import { NgSelectModule } from '@ng-select/ng-select';
import { MapModule } from './map/map.module';
import { ToastrModule } from 'ngx-toastr';
import { IndicatorsCapitalComponent } from './pages/indicators-capital/indicators-capital.component';
import { PdfBookViewerComponent } from './pages/pdf-book-viewer/pdf-book-viewer.component';

// ajustar
// import { MapLibModule } from 'node_modules/jirka-colombia-map/dist/map-lib';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    BannerComponent,
    HomeComponent,
    IndicatorsHomeComponent,
    CardComponent,
    CardPracticesComponent,
    TitleSectionComponent,
    LastNewsHorizontalComponent,
    ProjectsComponent,
    LoaderComponent,
    IndicatorsComponent,
    IndicatorsMunicipalityComponent,
    PublicationsComponent,
    MunicipalitiesComponent,
    PublicationDetailsComponent,
    LibrariesComponent,
    NewsComponent,
    AgnoskojComponent,
    FooterComponent,
    NewsDetailsComponent,
    SharingButtonsComponent,
    CapitalsComponent,
    StatesComponent,
    ContactComponent,
    GoodPracticesComponent,
    GoodPracticesDetailsComponent,
    IndicatorsCapitalComponent,
    PdfBookViewerComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    CarouselModule,
    ToastrModule.forRoot(), // ToastrModule added
    ChartsModule,
    MatProgressSpinnerModule,
    FormsModule,
    DataTableModule.forRoot(),
    NgxPaginationModule,
    FilterPipeModule,
    ShareButtonsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxGalleryModule,
    NgbModule,
    ModalesModule,
    NgSelectModule,
    MapModule
    // ShareModule
  ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
